import { gql } from 'apollo-angular';

export var committee_calendar_ready_dates = gql`
  query committeeCalendarReadyDates(
    $screeningProjects: Mixed
    $projects: Mixed
  ) {
    projectDates(
      hasProject: { column: ID, operator: IN, value: $screeningProjects }
      hasDateType: {
        column: NAME
        operator: IN
        value: ["Underwriting Screening Ready", "Construction Screening Ready"]
      }
      hasDateClass: { column: NAME, operator: IN, value: ["actual", "target"] }
    ) {
      id
      date
      project {
        id
        name
        participants {
          person {
            id
            name
          }
        }
      }
      dateType {
        id
        name
      }
      dateClass {
        id
        name
      }
    }
    projectMilestoneDates(
      hasProject: { column: ID, operator: IN, value: $projects }
      hasDateType: { column: NAME, operator: EQ, value: "Forecast Approval" }
    ) {
      id
      date
      pipelineMilestone {
        id
        milestone {
          name
        }
      }
      project {
        id
        name
        participants {
          person {
            id
            name
          }
        }
      }
    }
  }
`;
